let testdata = [48,51,60,61,76,122,163,172,151,99,84,87,115,142,145,121,78,63,62,90,110,108,82,44,35,48,62,78,85,69,31,12,20,28,47,56,46,24,5,29,47,51,51,41,17,7,18,21,26,36,29,9,0,4,17,29,36,25,5,6,21,21,15,19,25,12,15,18,11,5,0,0,0,5,7,10,11,11,5,0,16,17,15,19,18,18,13,5,6,10,16,26,26,24,23,23,27,33,47,44,30,28,30,22,39,50,45,31,22,18,23,22,36,46,38,32,21,11,15,18,23,22,20,15,12,13,31,34,29,33,36,30,41,45,39,35,33,34,26,12,2,0,0,0,0,0,11,21,21,17,24,27,26,20,24,23,16,18,27,23,18,35,36,30,27,18,22,16,16,22,17,15,15,12,17,32,40,38,34,28,28,38,48,50,42,37,28,32,42,50,57,45,43,44,27,23,28,36,47,42,51,51,42,50,78,83,70,42,25,37,49,49,58,60,52,51,47,70,79,86,98,101,95,90,97,101,99,94,87,67,71,80,78,74,65,52,37,33,34,57,79,79,74,82,72,76,78,95,93,95,94,94,96,95,86,80,91,99,96,98,89,83,104,104,98,95,97,95,103,104,102,105,95,78,83,105,109,95,90,100,93,92,91,90,105,106,102,95,72,96,99,100,91,98,90,91,97,102,107,105,97,93,87,78,72,72,82,83,88,89,91,99,91,67,49,39,27,44,38,48,65,72,81,77,69,75,88,88,70,66,67,77,81,70,70,89,97,98,99,94,89,100,98,84,96,90,71,66,60,80,85,72,43,19,36,26,3,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];

export default function fromElement(element_id, canvas_id, options) {
  const globalAccessKey = [options.globalAccessKey || "$wave"];
  const initGlobalObject = (elementId) => {
    window[globalAccessKey] = window[globalAccessKey] || {};
    window[globalAccessKey][elementId] = window[globalAccessKey][elementId] || {};
  };

  const getGlobal = options["getGlobal"] || function(elementId, accessKey) {
    initGlobalObject(elementId);
    return window[globalAccessKey][elementId][accessKey];
  };

  const setGlobal = options["setGlobal"] || function(elementId, accessKey, value) {
    let returnValue = getGlobal(elementId);
    if (!returnValue) {
      window[globalAccessKey][elementId][accessKey] = window[globalAccessKey][elementId][accessKey] || value;
      returnValue = window[globalAccessKey][elementId][accessKey];
    }
    return returnValue;
  };

  const waveContext = this;
  let element = document.getElementById(element_id);
  if (!element) return;
  element.crossOrigin = "anonymous";

  let stop = false;

  let initedPlay = false;
  function run() {
    //user gesture has happened
    this.activated = true;

    //track current wave for canvas
    this.activeCanvas = this.activeCanvas || {};
    this.activeCanvas[canvas_id] = JSON.stringify(options);

    //track elements used so multiple elements use the same data
    this.activeElements[element_id] = this.activeElements[element_id] || {};
    if (this.activeElements[element_id].count) this.activeElements[element_id].count += 1;
    else this.activeElements[element_id].count = 1;

    const currentCount = this.activeElements[element_id].count;

    const audioCtx = setGlobal(element.id, "audioCtx", new AudioContext());
    const analyser = setGlobal(element.id, "analyser", audioCtx.createAnalyser());

    let source = getGlobal(element.id, "source");
    if (source) {
      if (source.mediaElement !== element) {
        source = audioCtx.createMediaElementSource(element);
      }
    } else {
      source = audioCtx.createMediaElementSource(element);
    }
    setGlobal(element.id, "source", source);

    //beep test for ios
    const oscillator = audioCtx.createOscillator();
    oscillator.frequency.value = 1;
    oscillator.connect(audioCtx.destination);
    oscillator.start(0);
    oscillator.stop(0);

    source.connect(analyser);
    source.connect(audioCtx.destination);

    analyser.fftsize = 32768;
    const bufferLength = analyser.frequencyBinCount;
    const data = new Uint8Array(bufferLength);
    let frameCount = 1;

    let renderFrame = function() {
      //only run one wave visual per canvas
      if (JSON.stringify(options) !== this.activeCanvas[canvas_id]) {
        return;
      }

      //if the element or canvas go out of scope, stop animation
      if (!document.getElementById(element_id) || !document.getElementById(canvas_id))
        return;

      if (!stop) {
        requestAnimationFrame(renderFrame);
      }

      frameCount++;

      //check if this element is the last to be called
      if (!(currentCount < this.activeElements[element_id].count)) {
        analyser.getByteFrequencyData(data);
        this.activeElements[element_id].data = data;
      }
      if (initedPlay){
        this.visualize(this.activeElements[element_id].data, canvas_id, options, frameCount);

      }else{
        this.visualize(
          testdata
          , canvas_id, options, 1);
      }
    };

    renderFrame = renderFrame.bind(this);
    renderFrame();

  }


  const create = () => {
    //remove all events
    ["touchstart", "touchmove", "touchend", "mouseup", "click", "play"].forEach(event => {
      element.removeEventListener(event, create, { once: true });
    });

    run.call(waveContext);

    element.addEventListener("pause", function() {
      stop = true;
    });

    element.addEventListener("play", function() {
      stop = false;
      initedPlay = true;
      run.call(waveContext);
    });

    element.addEventListener("playing", function() {
      initedPlay = true;
    });
  };

  if (this.activated || options["skipUserEventsWatcher"]) {
    run.call(waveContext);
  } else {
    //wait for a valid user gesture
    document.body.addEventListener("touchstart", create, { once: true });
    document.body.addEventListener("touchmove", create, { once: true });
    document.body.addEventListener("touchend", create, { once: true });
    document.body.addEventListener("mouseup", create, { once: true });
    document.body.addEventListener("click", create, { once: true });
    element.addEventListener("play", create, { once: true });
  }

  this.visualize(
    testdata
    , canvas_id, options, 1);

}
